(function () {
  'use strict';
  const flow = window.DuvanzeCartFlow;
  const context = document.getElementById('duvanze-product-context');
  if (!context || !flow) return;
  const product = JSON.parse(context.textContent);
  if (!product.customizable) return;
  const scope = context.closest('.shopify-section');
  if (!scope) return;
  scope.classList.add('duvanze-custom-product');
  const original = flow.read();
  const editing = new URLSearchParams(location.search).get('duvanze_edit') === '1' && original.cartEdit?.mode === 'design' && original.productId === String(product.id);
  const incoming = editing ? original : {};
  const controlsSelector = 'input[name^="properties["], select[name^="properties["], textarea[name^="properties["]';
  const controls = () => Array.from(scope.querySelectorAll('.easify-product-options ' + controlsSelector.split(', ').join(', .easify-product-options ')));
  function active(el) {
    if (el.disabled) return false;
    const previewFile = el.type === 'file' && el.name === 'properties[Preview]';
    let node = el.type === 'hidden' || previewFile ? el.parentElement : el;
    while (node && node !== scope) {
      if (node.hidden || node.getAttribute('aria-hidden') === 'true' || getComputedStyle(node).display === 'none' || getComputedStyle(node).visibility === 'hidden') return false;
      node = node.parentElement;
    }
    return true;
  }
  function collect() {
    const properties = {};
    const files = new Map();
    const states = [];
    const current = controls().filter(active);
    current.forEach(el => {
      const match = el.name.match(/^properties\[(.+)\]$/);
      if (!match) return;
      if (el.type === 'file') {
        const file = el.files?.[0];
        if (file?.size) files.set(match[1], { key: match[1], file });
        return;
      }
      if (el.type !== 'hidden') states.push({ name: el.name, type: el.type, value: el.value, checked: el.checked, values: el.multiple ? Array.from(el.selectedOptions).map(o => o.value) : undefined });
      if ((el.type === 'radio' || el.type === 'checkbox') && !el.checked) return;
      const values = el.multiple ? Array.from(el.selectedOptions).map(o => o.value) : [el.value];
      values.filter(v => v !== '').forEach(value => { properties[match[1]] = properties[match[1]] ? properties[match[1]] + ', ' + value : String(value); });
    });
    files.forEach((_, key) => delete properties[key]);
    const clean = flow.designProperties(properties);
    const design = Object.fromEntries(Object.entries(clean).filter(([key]) => !key.startsWith('_') && key !== 'Preview'));
    const invalid = current.find(el => el.required && !el.checkValidity());
    const previewPending = !flow.hasPreview(clean, Array.from(files.values()));
    return { properties: clean, design, files: Array.from(files.values()), controls: states, invalid, previewPending, complete: !!Object.keys(design).length && !invalid && !previewPending };
  }
  function selectedVariant() {
    const valid = id => product.variants.some(v => String(v.id) === String(id));
    const candidate = Array.from(scope.querySelectorAll('form[action*="/cart/add"] [name="id"]')).find(el => !el.disabled && valid(el.value));
    const variant = product.variants.find(v => String(v.id) === String(candidate?.value || product.selectedVariantId));
    if (!variant?.available) throw new Error(flow.t('variant_unavailable'));
    return String(variant.id);
  }
  function draftFrom(selection) {
    const existing = flow.read();
    return {
      schemaVersion: 2, productId: String(product.id), productHandle: product.handle,
      productTitle: product.title, productImage: product.image, variantId: selectedVariant(),
      properties: selection.properties, design: selection.design, controls: selection.controls,
      profile: (editing ? incoming : existing).profile || {}, measurements: (editing ? incoming : existing).measurements || {},
      bodyShapeDetails: (editing ? incoming : existing).bodyShapeDetails || {},
      ...(editing ? { cartEdit: incoming.cartEdit, replacementUid: existing.replacementUid } : {}),
      ...(!editing && existing.addMode === false && existing.productId === String(product.id) && JSON.stringify(existing.properties) === JSON.stringify(selection.properties) ? { addUid: existing.addUid } : {})
    };
  }
  let busy = false;
  scope.addEventListener('click', async event => {
    const button = event.target.closest('#duvanze-continue-customization, #duvanze-add-later');
    if (!button) return;
    event.preventDefault(); event.stopImmediatePropagation();
    if (busy) return;
    busy = true; button.setAttribute('aria-busy', 'true');
    try {
      let selection = collect();
      const deadline = Date.now() + 5000;
      while (selection.previewPending && !selection.invalid && Object.keys(selection.design).length && Date.now() < deadline) {
        await new Promise(resolve => setTimeout(resolve, 250));
        selection = collect();
      }
      const later = button.id === 'duvanze-add-later';
      if ((!later || editing) && !selection.complete) {
        if (selection.invalid) selection.invalid.reportValidity();
        throw new Error(flow.t(selection.previewPending && !selection.invalid ? 'preview_required' : 'design_required'));
      }
      if (selection.previewPending && !selection.invalid && Object.keys(selection.design).length) throw new Error(flow.t('preview_required'));
      if (!selection.complete) { selection.properties = {}; selection.design = {}; selection.files = []; selection.controls = []; }
      const draft = draftFrom(selection);
      if (later) {
        if (editing) await flow.saveDesign(draft, selection.files);
        else await flow.add(draft, selection.files, false);
        flow.finish();
      } else {
        draft.fileDraftId = await window.DuvanzeDraftFiles.save(selection.files, draft.productId, draft.variantId);
        flow.write(draft);
        location.href = flow.route('pages/body-profile');
      }
    } catch (error) { alert(error.message); }
    finally { busy = false; button.removeAttribute('aria-busy'); }
  }, true);
  function sync() {
    const next = scope.querySelector('#duvanze-continue-customization');
    const later = scope.querySelector('#duvanze-add-later');
    if (next) next.hidden = !controls().length;
    if (later) {
      later.hidden = false;
      const text = flow.t(editing ? 'save_design' : 'add_later');
      if (later.textContent !== text) later.textContent = text;
    }
  }
  sync();
  new MutationObserver(sync).observe(scope, { childList: true, subtree: true });
  if (!editing) return;
  const notice = document.createElement('p');
  notice.className = 'dv-customizer-notice'; notice.setAttribute('role', 'status');
  notice.textContent = flow.t('restoring');
  const editPanel = document.createElement('div');
  editPanel.className = 'dv-customizer-edit-panel';
  const actionAnchor = scope.querySelector('#duvanze-continue-customization');
  if (actionAnchor) actionAnchor.before(editPanel);
  const cancel = document.createElement('a');
  cancel.href = flow.route('cart'); cancel.textContent = flow.t('cancel'); cancel.className = 'dv-cart-action';
  cancel.addEventListener('click', event => { event.preventDefault(); flow.finish(); });
  editPanel.append(notice, cancel);
  let saved;
  try { saved = JSON.parse(incoming.cartEdit.properties._duvanze_controls || '[]'); } catch (_) { saved = []; }
  if (!saved.length) saved = Object.entries(incoming.design || {}).map(([key, value]) => ({ name: 'properties[' + key + ']', value: String(value) }));
  let stop = false;
  let stableScans = 0;
  const applied = new Set();
  const deadline = Date.now() + 12000;
  function restore() {
    if (stop) return;
    let changed = false;
    const inputs = controls();
    saved.forEach((state, index) => {
      if (applied.has(index) || changed) return;
      const candidates = inputs.filter(el => el.name === state.name && el.type !== 'file' && el.type !== 'hidden');
      const el = candidates.find(el => !['radio', 'checkbox'].includes(el.type) || String(el.value) === String(state.value));
      if (!el || !active(el)) return;
      if (el.type === 'radio' || el.type === 'checkbox') {
        const checked = state.checked === undefined ? true : !!state.checked;
        if (el.checked !== checked) { el.click(); changed = true; }
      } else if (el.multiple && state.values) {
        Array.from(el.options).forEach(o => { o.selected = state.values.includes(o.value); });
        el.dispatchEvent(new Event('change', { bubbles: true })); changed = true;
      } else if (String(el.value) !== String(state.value)) {
        const proto = el.tagName === 'SELECT' ? HTMLSelectElement.prototype : el.tagName === 'TEXTAREA' ? HTMLTextAreaElement.prototype : HTMLInputElement.prototype;
        Object.getOwnPropertyDescriptor(proto, 'value').set.call(el, state.value);
        el.dispatchEvent(new Event('input', { bubbles: true }));
        el.dispatchEvent(new Event('change', { bubbles: true })); changed = true;
      }
      const matched = el.type === 'radio' || el.type === 'checkbox'
        ? el.checked === (state.checked === undefined ? true : !!state.checked)
        : el.multiple && state.values
          ? JSON.stringify(Array.from(el.selectedOptions).map(o => o.value)) === JSON.stringify(state.values)
          : String(el.value) === String(state.value);
      if (matched) applied.add(index);
    });
    if (applied.size === saved.length && !changed) stableScans += 1;
    else stableScans = 0;
    if (stableScans >= 2 || Date.now() > deadline) {
      stop = true;
      notice.textContent = flow.t(applied.size === saved.length ? 'review_design' : 'restore_partial');
    } else setTimeout(restore, 150);
  }
  scope.addEventListener('pointerdown', () => { if (!stop) { stop = true; notice.textContent = flow.t('review_design'); } }, { once: true });
  restore();
})();

